var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "box" }, [
    _vm.ok
      ? _c("i", {
          staticClass:
            "fas fa-check-circle fa-lg has-text-success is-pulled-right",
        })
      : _vm._e(),
    _vm._v(" "),
    _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Mi cuenta")]),
    _vm._v(" "),
    _c("h1", { staticClass: "title is-1" }, [_vm._v("Elegir firmador")]),
    _vm._v(" "),
    _c("p", {}, [
      _vm._v(
        "Seleccione que firmadores habilitados desea utilizar con Signar "
      ),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "block" },
      [
        _c(
          "b-field",
          [
            _c(
              "b-checkbox",
              {
                attrs: { type: "is-link", size: "is-medium" },
                model: {
                  value: _vm.model.signar,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "signar", $$v)
                  },
                  expression: "model.signar",
                },
              },
              [
                _vm._v("Firmador Desktop Signar® (\n        "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://firmador.lyris.com.ar/",
                      target: "_blank",
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-download" }),
                    _vm._v(" Se descarga desde aquí"),
                  ]
                ),
                _vm._v("\n      )\n      "),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-field",
          [
            _c(
              "b-checkbox",
              {
                attrs: { type: "is-link", size: "is-medium" },
                model: {
                  value: _vm.model.pfdrar,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "pfdrar", $$v)
                  },
                  expression: "model.pfdrar",
                },
              },
              [_vm._v("Firmador de Plataforma de Firma Digital Remota (PFDR)")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "buttons is-right" }, [
      _c(
        "button",
        {
          staticClass: "button is-primary",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.submit()
            },
          },
        },
        [_vm._v("Guardar")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }